import DesktopMemberAccess from './DesktopMemberAccess.component';

export default DesktopMemberAccess;
